// import { takeLatest, all, put, call, select } from "redux-saga/effects";
// import  licenceService  from "../../services/licence.service";
// import {
//   fetchLicenceData,  
//   deleteLicence,
//   licenceFetchFailed,
//   licenceFetchSuccess,
//   deleteLicenceFailed,
//   deleteLicenceSuccess,
//   resetPasswordFailed,
//   resetPasswordSuccess,
//   initiateResetPassword,
//   licenceAdded,
//   licenceUpdated,
// } from "../../features/licence/licenceSlice";

// import { error, success } from "../../features/toast/toastSlice";
// import { SUCCESS_PASSWORD_RESET_MAIL, DELETED } from "../../data/message";

// //Helper function to generate Query Array for Request call
// const handleQueryData = (queryData) => {
//   let { pageIndex, pageSize, filter } = queryData;
//   let offset = (pageIndex - 1) * pageSize;
//   let queryString = {};
//   queryString["limit"] = pageSize;
//   queryString["offset"] = offset;
//   for (let key in filter) {
//     if (filter[key]) {
//       queryString[key] = filter[key];
//     }
//   }
//   return {
//     ...queryString,
//   };
// };

// /**
//  * Make Rest API call to get conncetion serach data
//  * On Success store connection data in connection redux state
//  * On Failed update conncetion redux error state to show error on the Listing Page
//  *
//  * @param {Object} action
//  */
// function* fetchLicences(action) {
//   try {
//     let postData = handleQueryData(action.payload);
//     const { licenseSearchList, paging } = yield call(licenceService.licencesList, postData);
//     let { totalResults, resultCount } = paging;
//     if (licenseSearchList === null) {
//       yield put({
//         type: licenceFetchSuccess.toString(),
//         payload: { data: [], total: totalResults, resultCount },
//       });
//       return;
//     }
//     yield put({
//       type: licenceFetchSuccess.toString(),
//       payload: { data: licenseSearchList, total: totalResults, resultCount },
//     });
//   } catch (err) {
//     let { message } = err;
//     yield put({ type: licenceFetchFailed.toString(), payload: { message } });
//   }
// }


// /**
//  * Here we initiate a Rest API call to delete connection
//  * On success or Failed we update connection redux data
//  *
//  * @param {Object} action
//  */
// function* deleteLicenceData(action) {
//   try {
//     let id = action.payload;
//     yield call(licenceService.deleteLicence, id);
//     reInitiateLicenceList();
//     yield put({
//       type: success.toString(),
//       payload: { message: DELETED, delay: 5000 },
//     });
//     yield put({ type: deleteLicenceSuccess.toString(), payload: id });
//   } catch (err) {
//     let { message } = err;
//     if (message === "Database Error") {
//       message = "Some error occured.";
//     }
//     yield put({ type: error.toString(), payload: { message, delay: 3000 } });
//     yield put({ type: deleteLicenceFailed.toString(), payload: message });
//   }
// }

// function* reInitiateLicenceList() {
//   const queryData = yield select((state) => state.licence.queryData);
//   yield put({ type: fetchLicenceData.toString(), payload: queryData });
// }

// /**
//  * Make Rest API call to send reset password mail
//  *
//  * @param {Object} action
//  */
// function* makeResetPasswordRequest(action) {
//   try {
//     let { data, selectedLicences } = yield select((state) => state.licence);
//     let ids = Object.keys(selectedLicences);
//     let currentId = parseInt(ids[0]);
//     let { email } = data.find((c) => c.id === currentId);

//     yield call(licenceService.resetPassword, { email });
//     yield put({
//       type: success.toString(),
//       payload: { message: SUCCESS_PASSWORD_RESET_MAIL, delay: 3000 },
//     });
//     yield put({
//       type: resetPasswordSuccess.toString(),
//       payload: SUCCESS_PASSWORD_RESET_MAIL,
//     });
//   } catch (err) {
//     let { message } = err;
//     yield put({ type: error.toString(), payload: { message, delay: 3000 } });
//     yield put({ type: resetPasswordFailed.toString(), payload: message });
//   }
// }

// //Listener for Connection List request
// function* watchListRequest() {
//   yield takeLatest(fetchLicenceData.toString(), fetchLicences);
// }

// //Listener for deleteConnection request
// function* watchDeleteRequest() {
//   yield takeLatest(deleteLicence.toString(), deleteLicenceData);
// }

// //Listener for Password reset mail request
// function* watchResetPasswordRequest() {
//   yield takeLatest(initiateResetPassword.toString(), makeResetPasswordRequest);
// }

// //Listener for deleteConnection request
// function* watchLicenceUpdated() {
//   yield takeLatest(licenceUpdated.toString(), reInitiateLicenceList);
// }

// //Listener for deleteConnection request
// function* watchLicenceAdded() {
//   yield takeLatest(licenceAdded.toString(), reInitiateLicenceList);
// }

// export default function* licenceSearchSaga() {
//   yield all([
//     watchListRequest(),
//     watchDeleteRequest(),
//     watchResetPasswordRequest(),
//     watchLicenceAdded(),
//     watchLicenceUpdated(),
//   ]);
// }

import { takeLatest, all, put, call, select } from "redux-saga/effects";
import licenceService from "../../services/licence.service";
import {
  fetchLicenceData,
  deleteLicence,
  licenceFetchFailed,
  licenceFetchSuccess,
  deleteLicenceFailed,
  deleteLicenceSuccess,
  resetPasswordFailed,
  resetPasswordSuccess,
  initiateResetPassword,
  licenceAdded,
  licenceUpdated,
} from "../../features/licence/licenceSlice";

import { error, success } from "../../features/toast/toastSlice";
import { SUCCESS_PASSWORD_RESET_MAIL, DELETED } from "../../data/message";

/** helpers */
const toStr = (v) => (v === null || v === undefined ? "" : String(v));

const normalizeQuickSearchForApi = (s) => {
  const raw = toStr(s).trim();
  if (!raw) return "";

  // 27.07.2029 / 27/07/2029 / 27-07-2029 => 2029-07-27
  const m = raw.match(/^(\d{1,2})[.\-/](\d{1,2})[.\-/](\d{4})$/);
  if (m) {
    const dd = m[1].padStart(2, "0");
    const mm = m[2].padStart(2, "0");
    const yyyy = m[3];
    return `${yyyy}-${mm}-${dd}`;
  }
  return raw;
};

//Helper function to generate Query Array for Request call
const handleQueryData = (queryData) => {
  const pageIndexRaw = Number(queryData?.pageIndex ?? 0);
  const pageSizeRaw = Number(queryData?.pageSize ?? 10);

  // ✅ pageIndex 0-based kabul: 0,1,2...
  const pageIndex = Number.isFinite(pageIndexRaw) ? Math.max(0, pageIndexRaw) : 0;
  const pageSize = Number.isFinite(pageSizeRaw) && pageSizeRaw > 0 ? pageSizeRaw : 10;

  const filter = queryData?.filter && typeof queryData.filter === "object" ? queryData.filter : {};

  // ✅ offset negatif olmasın
  const offset = Math.max(0, pageIndex * pageSize);

  // ✅ API param isimleri (endpoint dokümanına göre)
  const queryString = {
    limit: pageSize,
    offset,
  };

  // ✅ filter key map (UI -> API)
  // UI: productCode -> API: product
  // UI: partnerId -> API: reseller
  // UI: statusId -> API: status
  // UI: supportTypeName -> API: support (integer)
  // UI: supportType -> API: supportType
  const mapped = {
    ...filter,
    status: filter?.statusId ?? filter?.status,
    product: filter?.productCode,
    reseller: filter?.partnerId,
    support: filter?.supportTypeName,
    supportType: filter?.supportType,
    quickSearch: normalizeQuickSearchForApi(filter?.quickSearch),
    licenseNo: toStr(filter?.licenseNo).replace(/\s+/g, ""),
    owner: toStr(filter?.owner),
    version: toStr(filter?.version),
  };

  // ✅ Eski isimleri sil (çift gitmesin)
  delete mapped.statusId;
  delete mapped.productCode;
  delete mapped.partnerId;
  delete mapped.supportTypeName;

  // ✅ 0 değerlerini kaybetme: filter[key] yerine null/undefined/"" kontrolü
  for (let key in mapped) {
    const v = mapped[key];
    if (v === undefined || v === null || v === "") continue;

    // number string ise (select value) gönder
    queryString[key] = v;
  }

  return queryString;
};

/**
 * Make Rest API call to get licence search data
 */
function* fetchLicences(action) {
  try {
    const postData = handleQueryData(action.payload);

    // ⚠️ licenceService.licencesList axios response'u data döndürüyor mu?
    // Eğer service'iniz res.data döndürmüyorsa, aşağıdaki satırda data'ya göre uyarlayın.
    const res = yield call(licenceService.licencesList, postData);

    // res ya {licenseSearchList,paging} ya da {data:{...}} olabilir:
    const licenseSearchList = res?.licenseSearchList ?? res?.data?.licenseSearchList ?? [];
    const paging = res?.paging ?? res?.data?.paging ?? { totalResults: 0, resultCount: 0 };

    const totalResults = Number(paging?.totalResults ?? 0);
    const resultCount = Number(paging?.resultCount ?? 0);

    yield put({
      type: licenceFetchSuccess.toString(),
      payload: {
        data: Array.isArray(licenseSearchList) ? licenseSearchList : [],
        total: totalResults,
        resultCount,
      },
    });
  } catch (err) {
    const message = err?.response?.data?.message || err?.message || "Request failed";
    yield put({ type: licenceFetchFailed.toString(), payload: { message } });
  }
}

/**
 * Delete licence
 */
function* deleteLicenceData(action) {
  try {
    const id = action.payload;
    yield call(licenceService.deleteLicence, id);
    yield call(reInitiateLicenceList);
    yield put({
      type: success.toString(),
      payload: { message: DELETED, delay: 5000 },
    });
    yield put({ type: deleteLicenceSuccess.toString(), payload: id });
  } catch (err) {
    let message = err?.message || "Some error occured.";
    if (message === "Database Error") message = "Some error occured.";
    yield put({ type: error.toString(), payload: { message, delay: 3000 } });
    yield put({ type: deleteLicenceFailed.toString(), payload: message });
  }
}

function* reInitiateLicenceList() {
  const queryData = yield select((state) => state.licence.queryData);
  yield put({ type: fetchLicenceData.toString(), payload: queryData });
}

/**
 * Reset password request
 */
function* makeResetPasswordRequest(action) {
  try {
    const { data, selectedLicences } = yield select((state) => state.licence);
    const ids = Object.keys(selectedLicences || {});
    const currentId = parseInt(ids[0], 10);
    const found = Array.isArray(data) ? data.find((c) => c.id === currentId) : null;
    const email = found?.email;

    if (!email) {
      yield put({ type: error.toString(), payload: { message: "Email not found", delay: 3000 } });
      yield put({ type: resetPasswordFailed.toString(), payload: "Email not found" });
      return;
    }

    yield call(licenceService.resetPassword, { email });
    yield put({
      type: success.toString(),
      payload: { message: SUCCESS_PASSWORD_RESET_MAIL, delay: 3000 },
    });
    yield put({
      type: resetPasswordSuccess.toString(),
      payload: SUCCESS_PASSWORD_RESET_MAIL,
    });
  } catch (err) {
    const message = err?.response?.data?.message || err?.message || "Request failed";
    yield put({ type: error.toString(), payload: { message, delay: 3000 } });
    yield put({ type: resetPasswordFailed.toString(), payload: message });
  }
}

//Listener
function* watchListRequest() {
  yield takeLatest(fetchLicenceData.toString(), fetchLicences);
}
function* watchDeleteRequest() {
  yield takeLatest(deleteLicence.toString(), deleteLicenceData);
}
function* watchResetPasswordRequest() {
  yield takeLatest(initiateResetPassword.toString(), makeResetPasswordRequest);
}
function* watchLicenceUpdated() {
  yield takeLatest(licenceUpdated.toString(), reInitiateLicenceList);
}
function* watchLicenceAdded() {
  yield takeLatest(licenceAdded.toString(), reInitiateLicenceList);
}

export default function* licenceSearchSaga() {
  yield all([
    watchListRequest(),
    watchDeleteRequest(),
    watchResetPasswordRequest(),
    watchLicenceAdded(),
    watchLicenceUpdated(),
  ]);
}